<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-btn flat slot="activator" @click="loadFeatures()">
      <v-icon>settings</v-icon>
    </v-btn>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-side-icon></v-toolbar-side-icon>
        <v-toolbar-title>Edit features [{{flat.gw}}]</v-toolbar-title>
        <v-spacer/>
        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="category in categories"
              :key="category.id"
              @click="addFeature(category.id)"
            >
              <v-list-tile-title>{{$t(category.id)}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-list subheader>
        <span v-for="(items, category) in localFeatures" :key="category">
          <v-divider/>

          <v-subheader>{{$t(category)}}</v-subheader>
          <v-list-tile style="width: 100%" v-for="item in items" :key="item.address" avatar>
            <v-list-tile-avatar>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon :color="item.color">{{item.icon}}</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-container grid-list-xs>
                    <v-layout rpw wrap>
                      <v-flex xs3 v-for="icon in icons" :key="icon">
                        <v-btn icon @click="item.icon = icon">
                          <v-icon>{{icon}}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-menu>
            </v-list-tile-avatar>
            <v-layout row wrap>
              <v-flex xs9>
                <v-text-field v-model="item.title" autofocus></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="item.address" autofocus></v-text-field>
              </v-flex>
            </v-layout>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-list-tile-avatar>
                    <v-btn icon v-on="on">
                      <v-icon :color="item.color">color_lens</v-icon>
                    </v-btn>
                  </v-list-tile-avatar>
                </template>
                <swatches-picker :value="item.color" @input="updateColor($event, item)"></swatches-picker>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </span>
      </v-list>

      <transition name="fade">
        <v-card-text v-if="error" class="error-msg">
          <p>{{error}}</p>
        </v-card-text>
      </transition>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from 'vuex';
import router from '@/router';
import { constants } from 'fs';
import { Photoshop, Swatches } from 'vue-color';

export default {
  name: 'gateway-edit-features',
  props: ['flat'],
  components: {
    'photoshop-picker': Photoshop,
    'swatches-picker': Swatches
  },

  mounted() {
    console.log(this.$options.name + ': ', this.flat);
    this.$store.dispatch('gateways/get', this.flat.gw);
  },
  data: () => {
    return {
      colors: '#FF0000',
      icons: [
        'vpn_key',
        'cloud',
        'camera_alt',
        'whatshot',
        'opacity',
        'touch_app',
        'visibility'
      ],
      categories: [
        {
          id: 'cameras'
        },
        {
          id: 'sensors'
        },
        {
          id: 'actuators'
        }
      ],
      dialog: false,
      editing: false,
      error: null,
      localFeatures: {}
    };
  },
  computed: {
    ...mapState('gateways', ['gateways'])
  },
  methods: {
    updateColor(value, item) {
      console.log(value, item);
      item.color = value.hex;
    },
    loadFeatures: function() {
      console.log('All gateways are: ', this.gateways);

      const found = this.gateways.find(item => item.gateway == this.flat.gw);
      if (found) {
        console.log('Found features of ' + this.flat.gw + ' are: ', found);
      }
      let features = {
        sensors: found.sensors,
        actuators: found.actuators,
        cameras: found.cameras
      };
      this.localFeatures = JSON.parse(JSON.stringify(features));
    },
    addFeature(category) {
      if (!this.localFeatures[category]) this.localFeatures[category] = [];
      let defaultAddress =
        Math.max(...this.localFeatures[category].map(item => item.address), 0) +
        1;
      let defaultIcon = 'photo';
      let defaultColor = '#123456';
      this.localFeatures[category].push({
        address: defaultAddress,
        icon: defaultIcon,
        color: defaultColor,
        title: 'The name of the feature'
      });
      console.log(this.localFeatures);
    },
    save: function() {
      this.$store
        .dispatch('gateways/put', {
          gateway: this.flat.gw,
          ...this.localFeatures
        })
        .then(() => {
          this.dialog = false;
          router.push('/');
        })
        .catch(e => {
          //segnalare l'errore
          console.log(e.response);
          this.error = e.response.data.message || e;
        });
    }
  }
};
</script>

<style>
</style>
